/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PartialLabelData } from './PartialLabelData';

/**
 * CatalogItemOut schema for webhooks containing only relevant fields for external integrations
 */
export type CatalogItemWebhookData = {
  /**
   * The event that triggered this webhook, for example order.created
   */
  type: CatalogItemWebhookData.type;
  /**
   * Catalog item id
   */
  id: string;
  /**
   * Id of the account that owns the item
   */
  account_id: string;
  /**
   * Id of the catalog category the item belongs to
   */
  category_id: string;
  /**
   * Item name, per language
   */
  name: PartialLabelData;
  /**
   * Item description, per language
   */
  description?: PartialLabelData;
  /**
   * Item photo URL
   */
  photo_url?: string;
  /**
   * Unit price in the account currency
   */
  price: number;
  /**
   * Free-form tags of the item
   */
  tags?: Array<string>;
  /**
   * True once the item is deleted
   */
  archived?: boolean;
  /**
   * UTC time the item was created
   */
  created_at: string;
  /**
   * UTC time the item was last updated
   */
  updated_at: string;
};

export namespace CatalogItemWebhookData {
  /**
   * The event that triggered this webhook, for example order.created
   */
  export enum type {
    CATALOG_ITEM_CREATED = 'catalog_item.created',
    CATALOG_ITEM_UPDATED = 'catalog_item.updated',
    CATALOG_ITEM_DELETED = 'catalog_item.deleted',
  }
}
